import type { SDKConfig, SDKError } from './types/config';
import type { SfpVendor } from './vendor/sfp-vendor';

/**
 * Context information and state related to an instance of Sfp.
 */
export default class SfpContext {
  vendorAccountToHandler: Map<string, SfpVendor> = new Map<string, SfpVendor>();
  private config: SDKConfig;

  constructor(config: SDKConfig) {
    this.config = config;
  }

  report(error: SDKError): void {
    try {
      this.config?.report?.(error);
    } catch (err) {
      // Do nothing, since the error reporting function itself threw an error
    }
  }
}
